import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { DealListItemResponse } from 'app/console-api';
import Select from 'react-select';
import { StatisticsFiltersStyles } from 'app/components/common/common-styles';

type DealsOption = {
  id: string;
  value: string;
  label: string;
};

export const DealsListFilterAdapter: FilterAdapter<string[]> = {
  key: 'deals',
  fromUrl: (sp) => {
    const raw = sp.get('deals');
    if (!raw) return null;
    const arr = raw
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    return arr.length ? arr : null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value || value.length === 0) {
      next.delete('deals');
    } else {
      next.set('deals', value.join(','));
    }
    return next;
  },
  toKey: (v) => `deals:${v && v.length ? [...v].sort().join(',') : 'all'}`
};

type DealsListFilterProps = {
  deals: DealListItemResponse[];
} & Record<string, any>;

export const DealsListFilter = ({ deals, props }: DealsListFilterProps) => {
  const ctl = useUrlFilterController();
  const value = ctl.get(DealsListFilterAdapter) ?? []; // string[] of selected deal IDs
  const options: DealsOption[] = deals.map((deal) => ({
    id: deal.dealDetails.id,
    value: deal.dealDetails.id,
    label: deal.dealDetails.title
  }));

  // react-select multi expects an array of option objects
  const selected = options.filter((o) => value.includes(o.value));

  return (
    <Select<DealsOption, true>
      styles={StatisticsFiltersStyles()}
      {...props}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={options}
      value={selected}
      placeholder={'All Deals'}
      onChange={(opts: any) => {
        const selectedDealIds = opts ? opts.map((o: any) => o.value) : [];
        ctl.set(DealsListFilterAdapter, selectedDealIds.length ? selectedDealIds : null);
      }}
    />
  );
};
